import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SitesComponent } from './sites/sites.component';
import { SiteItemComponent } from './sites/site-item/site-item.component';
import { ShiftsComponent } from './shifts/shifts.component';
import { ShiftItemComponent } from './shifts/shift-item/shift-item.component';
import { FsItemComponent } from './shifts/fs-item/fs-item.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { NavComponent } from './nav/nav.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
// import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// import { InMemoryDataService } from './in-memory-data.service';
import { HttpClientModule } from '@angular/common/http';
import { ChartModule } from 'angular2-highcharts';
import * as highcharts from 'highcharts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  MatGridListModule,
          MatFormFieldModule,
          MatInputModule,
          MatDatepickerModule,
          MatNativeDateModule,
          MatDividerModule,
          MatListModule,
          MatButtonModule,
          MatIconModule,
          MatDialogModule,
          MatTableModule,
          MatSelectModule,
          MatPaginatorModule,
          MatTooltipModule,
          MatProgressBarModule,
          MatProgressSpinnerModule,
          MatMenuModule,
          MatBadgeModule,
          MatToolbarModule,
          MatSidenavModule,
          MatRadioModule
        } from '@angular/material';
// import { Browser } from 'protractor';
import { RemoveFsConfirmComponent } from './shifts/fs-item/remove-fs-confirm/remove-fs-confirm.component';
import { AddFsComponent } from './shifts/add-fs/add-fs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditFsComponent } from './shifts/fs-item/edit-fs/edit-fs.component';
import { RemoveFsAssignmentConfirmComponent } from './shifts/shift-item/remove-fs-assignment-confirm/remove-fs-assignment-confirm.component';
import { AddInspectorComponent } from './shifts/shift-item/add-inspector/add-inspector.component';
import { AddAgencyComponent } from './shifts/shift-item/add-agency/add-agency.component';
import { ConfirmComponent } from './shifts/shift-item/confirm/confirm.component';
import { LoginComponent } from './login/login.component';
import { GlobalEventsManager } from './global-events-manager';
import { CountriesComponent } from './countries/countries.component';
import { BranchesComponent } from './branches/branches.component';
import { CountryItemComponent } from './countries/country-item/country-item.component';
import { BranchItemComponent } from './branches/branch-item/branch-item.component';
import { ChooseActionComponent } from './shifts/shift-item/choose-action/choose-action.component';
import { ShiftItemInfoComponent } from './shifts/shift-item/shift-item-info/shift-item-info.component';
import { AddEmailAndPhoneComponent } from './shifts/shift-item/add-email-and-phone/add-email-and-phone.component';
import { InfoDialogComponent } from './nav/info-dialog/info-dialog.component';
import { MyDayComponent } from './my-day/my-day.component';
import { SitePpeComponent } from './my-day/site-ppe/site-ppe.component';
import { ActiveWoComponent } from './my-day/active-wo/active-wo.component';
import { InspectorInfoComponent } from './my-day/inspector-info/inspector-info.component';
import { AlertDialogComponent } from './nav/alert-dialog/alert-dialog.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MyBranchComponent } from './my-branch/my-branch.component';
import { MovingFsComponent } from './my-branch/moving-fs/moving-fs.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { AgencyEmailDialogComponent } from './nav/agency-email-dialog/agency-email-dialog.component';

const appRoutes: Routes = [
  { path: 'sites', component: SitesComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    SitesComponent,
    SiteItemComponent,
    ShiftsComponent,
    ShiftItemComponent,
    FsItemComponent,
    TransactionHistoryComponent,
    NavComponent,
    RemoveFsConfirmComponent,
    AddFsComponent,
    EditFsComponent,
    RemoveFsAssignmentConfirmComponent,
    AddInspectorComponent,
    AddInspectorComponent,
    AddAgencyComponent,
    ConfirmComponent,
    LoginComponent,
    CountriesComponent,
    BranchesComponent,
    CountryItemComponent,
    BranchItemComponent,
    ChooseActionComponent,
    ShiftItemInfoComponent,
    AddEmailAndPhoneComponent,
    InfoDialogComponent,
    MyDayComponent,
    SitePpeComponent,
    ActiveWoComponent,
    InspectorInfoComponent,
    AlertDialogComponent,
    MyBranchComponent,
    MovingFsComponent,
    FeedbackDialogComponent,
    AgencyEmailDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(appRoutes, {useHash: true}),
    AppRoutingModule,
    HttpClientModule,
    MatPaginatorModule,
    ChartModule.forRoot(highcharts),
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatBadgeModule,
    MatToolbarModule,
    MatSidenavModule,
    FlexLayoutModule,
    MatRadioModule
  ],
  exports: [
  ],
  providers: [ GlobalEventsManager ],
  bootstrap: [AppComponent],
  entryComponents: [
    RemoveFsConfirmComponent,
    AddFsComponent,
    EditFsComponent,
    RemoveFsAssignmentConfirmComponent,
    AddInspectorComponent,
    AddAgencyComponent,
    ConfirmComponent,
    TransactionHistoryComponent,
    ChooseActionComponent,
    ShiftItemInfoComponent,
    InfoDialogComponent,
    ShiftItemInfoComponent,
    AddEmailAndPhoneComponent,
    SitePpeComponent,
    ActiveWoComponent,
    InspectorInfoComponent,
    AlertDialogComponent,
    MovingFsComponent,
    FeedbackDialogComponent,
    AgencyEmailDialogComponent
  ]
})
export class AppModule { }
